import React from 'react';
import { CheckCircle2Icon, ZapIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { instantAccessItems } from '../data/curriculum';
export function InstantAccessSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-28" data-id="element-96" data-mp="1mf2d7e4be4uq">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-97" data-mp="1mgn8x72d7tu6">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-brand-amber/15 text-brand-amber" data-id="element-98" data-mp="1hnajwvtrxl0w">
          <ZapIcon className="h-6 w-6" aria-hidden="true" data-id="element-99" data-mp="1wf30tc97v74q" />
        </div>
        <h2 className="mb-12 text-3xl font-black text-brand-deep md:text-4xl" data-id="element-100" data-mp="1rd3vvxxtw25o">⚡ What Do You Get Instantly?</h2>
        <div className="space-y-3 text-left" data-id="element-101" data-mp="25d4ypixnljns">
          {instantAccessItems.map(item => <div key={item} className="flex items-center gap-4 rounded-2xl border border-brand-dark bg-brand-alt p-5 shadow-sm" data-id="element-102" data-mp="20f3euvselgb9">
              <CheckCircle2Icon className="h-6 w-6 shrink-0 text-brand-green" aria-hidden="true" data-id="element-103" data-mp="61c8q69a9ekk" />
              <span className="font-semibold" data-id="element-104" data-mp="2n2gdu8lyp9vg">{item}</span>
            </div>)}
        </div>
        <p className="mt-10 font-serif text-2xl font-bold italic text-brand-green" data-id="element-105" data-mp="2rzyr2b70ib99">You never run out of material.</p>
      </Reveal>
    </section>;
}